import { VehicleCountByCompanyDetailsIdDataOutput } from './vehicle-count-by-company-details-id-data-output.model';


export class VehicleCountByCompanyDetailsIdOutput implements IVehicleCountByCompanyDetailsIdOutput {
    status!: number;
    message!: string;
    data!: VehicleCountByCompanyDetailsIdDataOutput;

    constructor(data?: IVehicleCountByCompanyDetailsIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? VehicleCountByCompanyDetailsIdDataOutput.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VehicleCountByCompanyDetailsIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleCountByCompanyDetailsIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IVehicleCountByCompanyDetailsIdOutput {
    status: number;
    message: string;
    data: VehicleCountByCompanyDetailsIdDataOutput;
}

